import React, {Component} from 'react';
// import { Row, Col, FormControl, Form, FormGroup } from 'react-bootstrap';
// import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';
import { momentHelper } from '../report/helpers'
import FontAwesome from 'react-fontawesome';

const month = momentHelper.getMonth()
const year = momentHelper.getYear()
const day = momentHelper.getDay()
const DEFAULT_ROW = 6
class PrintKKCBillingNoteCompany extends Component {

  constructor(...args){
    super(...args)

    this.state = {loading:false,data:{},dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    let {data,dataList} = this.state
    PdfStore.loadBillingNoteDoc('ivlist',this.props.ivList,(result) => {
      data = result.data
      dataList = this.getPagination(result.data.list)
      this.setState({data:data,dataList:dataList,report_title:'ไม่พบข้อมูล'})
    })
  }

  renderSignature() {
    return(
      <table className='table table-header-print-kkc-billing-note'>
        <tbody>
          <tr>
            <td className='text-center'>ลงชื่อ..............................ผู้วางบิล</td>
            <td className='text-center'>ลงชื่อ..............................ผู้รับวางบิล</td>
          </tr>
          <tr>
            <td className='text-center'>{'วันที่ '+day+'/'+month+'/'+year}</td>
            <td className='text-center'>วันที่........./........./.........</td>
          </tr>
        </tbody>
      </table>
    )  
  }

  renderHeader() {
    let {data} = this.state
    return(
      <table className='table table-header-print-kkc-billing-note' style={{marginBottom:'0'}}>
        <tbody>
          <tr>
            <td style={{width:'80px'}}>เลขที่</td>
            <td style={{width:'500px'}}></td>
            <td className='text-right'>{'วันที่ '+day+'/'+month+'/'+year}</td>
          </tr>
          <tr>
            <td>ชื่อเจ้าของรถ</td>
            <td>{data.customer!==undefined?data.customer.customer_name:''}</td>
          </tr>
          <tr>
            <td>ที่อยู่</td>
            <td>{data.customer!==undefined?data.customer.customer_address:''}</td>
          </tr>
          <tr>
            <td colSpan={3} className='text-center'>ขอนำส่งเอกสารเพื่อขอเบิกค่าซ่อม ตามรายการดังต่อไปนี้</td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderRowData(item) {
    if (item.length===0) {
      return(
        <tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        item.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.purchase_order_no}</td>
              <td className='text-center'>{item.invoice_no}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
              <td className='text-center'>{item.work_no}</td>
            </tr>
          )
        })  
      )    
    }      
  }

  renderTable(item) {
     return(
      <div className=''>
        <table className='table table-responsive table-hover table-bordered-solid table-print-kkc-billing-note'>
          <thead>
            <tr>
              <th className='text-center bg-none' style={{width:'1px'}}>ลำดับ</th>
              <th className='text-center bg-none' style={{width:'80px'}}>เลขที่ P/O</th>
              <th className='text-center bg-none' style={{width:'80px'}}>เลขที่ใบแจ้งหนี้</th>
              <th className='text-center bg-none' style={{width:'120px'}}>ทะเบียน</th>
              <th className='text-center bg-none' style={{width:'50px'}}>จำนวนเงิน</th>
              <th className='text-center bg-none' style={{width:'80px'}}>ลำดับ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData(item)}
          </tbody>
          <tfoot>
            <tr>
              <th className='text-center bg-none' colSpan={3}>รวมทั้งสิ้น</th>
              <th className='text-center bg-none'></th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary(item))}</th>
              <th className='text-center bg-none'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )      
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    return ''
  }

  // getSummary() {
  //   let {data} = this.state
  //   let sum = 0
  //   data.list.forEach(function(item,index) {
  //     let amount = item.amount
  //     if (amount===''||amount===null||amount===undefined||isNaN(amount))
  //       amount = 0

  //     sum += parseFloat(amount)
  //   })
  //   return sum
  // }

  getSummary(data) {
    let sum = 0
    data.forEach(function(item,index) {
      let amount = item.amount
      if (amount===''||amount===null||amount===undefined||isNaN(amount))
        amount = 0

      sum += parseFloat(amount)
    })
    return sum
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderCompany(item,index) {
    let {data} = this.state
    return(
      [ 
        <header key={'h-'+index}>
          <h2>{this.props.title}</h2>
        </header>,
        <article className={"article-company "+data.logo_class} key={'a-'+index}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>             
            </strong>
          </section>
          <section className='text-right sec-copy-doc'>
            <span>{data.list.length>DEFAULT_ROW?(item.page===1?'ต้นฉบับ':'สำเนา'):(index===0?'ต้นฉบับ':'สำเนา')}</span>  
          </section>
        </article>
      ]
    )
  }

  renderAll(item) {
    return(
      item.list.map((sub_item,index) => {
        return(
          <div key={index}>
            {this.renderCompany(item,index)}
            <div className='font-16'>   
              {this.renderHeader()}
              {this.renderTable(sub_item)}
              {this.renderSignature()}
            </div>
            <div style={{width:'100%',display:item.list.length>1&&item.list.length-1!==index?'':'none'}}>
              <div style={{width:'5%',float:'left'}}>
                <FontAwesome name='scissors' className='scissors' />
              </div>
              <div style={{width:'95%',float:'right'}}>
                <hr className='hr-billing-note' />
              </div> 
            </div>
          </div>
        )
      })
    )  
  }

  renderComponentPage(item,index,total) {
    return(
      <div className='font-print' key={index}>
        {this.renderAll(item)}  
      </div>  
    )
  }

  getPagination(data) {
    let allData = []
    let setData = []

    if (data.length<DEFAULT_ROW) {
      for (var i=data.length;i<DEFAULT_ROW;i++) {
        data.push({
          purchase_order_no:'',
          invoice_no:'',
          car_registration_no:'',
          amount:'',
          work_no:'',
          claim_no:'',
          quotation_no:'',
        })
      }
    }

    if (data.length>DEFAULT_ROW) {
      setData.push(data)
      allData.push({
        list: setData,
        page: 1
      })
      allData.push({
        list: setData,
        page: 2
      })
    } else {
      setData.push(data)
      setData.push(data)
      allData.push({
        list: setData,
        page: 1
      })
    }

    return allData
  }

  // getPagination(data) {
  //   let allData = []
  //   let setData = []

  //   if (data.length<DEFAULT_ROW) {
  //     for (var i=data.length;i<DEFAULT_ROW;i++) {
  //       data.push({
  //         purchase_order_no:'',
  //         invoice_no:'',
  //         car_registration_no:'',
  //         amount:'',
  //         work_no:'',
  //         claim_no:'',
  //         quotation_no:'',
  //       })
  //     }
  //   }

  //   if (data.length>DEFAULT_ROW) {
  //     let dataObj = []
  //     let checkPage = 1
  //     let checkRow = 0
  //     data.forEach((item,index)=>{
  //       if (checkRow<DEFAULT_ROW) {
  //         dataObj.push(item)
  //         checkRow++
  //       }
  //       if (index===DEFAULT_ROW-1||index===data.length-1) {
  //         if (dataObj.length<DEFAULT_ROW) {
  //           for (var i=dataObj.length;i<DEFAULT_ROW;i++) {
  //             dataObj.push({
  //               purchase_order_no:'',
  //               invoice_no:'',
  //               car_registration_no:'',
  //               amount:'',
  //               work_no:'',
  //               claim_no:'',
  //               quotation_no:'',
  //             })
  //           }
  //         }
  //         setData.push(dataObj)
  //         setData.push(dataObj)
  //         allData.push({
  //           list: setData,
  //           page: checkPage
  //         })
  //         checkPage++
  //         dataObj = []
  //         setData = []
  //         checkRow = 0
  //       }
  //     })
  //   } else {
  //     setData.push(data)
  //     setData.push(data)
  //     allData.push({
  //       list: setData,
  //       page: 1
  //     })
  //   }
    
  //   return allData
  // }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
          showPageNumber={false}
        >
          {
            dataList.map((item,index) => {
              return(
                this.renderComponentPage(item,index,dataList.length)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintKKCBillingNoteCompany.defaultProps = {
  title: 'ใบวางบิล',  
  mode : '1'
}
export default PrintKKCBillingNoteCompany;


// WEBPACK FOOTER //
// ./src/view/print/PrintKKCBillingNoteCompany.js